export const ICONS = {
  lens: "binoculars",
  memberLens: "user-focus",
  channelLens: "hash-straight",
  growth: "trend-up",
  engagement: "chats-circle",
  audience: "users-three",
  leaderboards: "ranking",
  levels: "steps",
  inviteLinks: "link-simple",
  claims: "stamp",
  memberPictures: "user-square",
  inbox: "tray",
  analytics: "chart-line-up",
  intelligence: "sparkle",
  rewards: "trophy",
  campaigns: "rocket-launch",
  workspace: "gear-six",
  pulse: "pulse",
  briefing: "newspaper-clipping",
  annotation: "flag",
  annotationRules: "flag-pennant",
  compare: "arrows-left-right",
  events: "calendar-star",
  inviters: "hand-waving",
  serverSettings: "sliders",
  earningSettings: "gauge",
  gamification: "game-controller",
  billing: "wallet",
  panelSettings: "sliders-horizontal",
  xp: "arrow-fat-lines-up",
  multiplier: "lightning",
  perks: "gift",
  cards: "cards-three",
  rankCard: "identification-card",
  levelUp: "confetti",
  images: "images",
  giveaways: "ticket",
  giveawayEntries: "user-list",
  giveawayEnd: "flag-checkered",
  saveTemplate: "stack-plus",
  random: "dice-five",
  tenants: "hard-drives",
  accounts: "address-book",
  showcase: "storefront",
  publicBot: "globe-simple",
  audit: "scroll",
  terms: "file-text",
  markdown: "markdown-logo",
  demo: "monitor-play",
  privacy: "shield-check",
  support: "lifebuoy",
  guide: "book-open-text",
  textChannel: "hash",
  announcementChannel: "megaphone-simple",
  forumChannel: "chats-teardrop",
  voiceChannel: "speaker-high",
  stageChannel: "microphone-stage",
  thread: "arrow-elbow-down-right",
  category: "folder-simple",
  role: "shield",
  people: "users",
  person: "user",
  avatar: "user-circle",
  team: "user-gear",
  ownership: "crown-simple",
  bot: "robot",
  ownBot: "plugs-connected",
  managedRole: "seal-check",
  messages: "chat-centered-text",
  voice: "microphone",
  commands: "terminal-window",
  emoji: "smiley",
  apps: "puzzle-piece",
  add: "plus",
  delete: "trash",
  dismiss: "x",
  more: "dots-three",
  edit: "pencil-simple",
  duplicate: "copy",
  copy: "clipboard-text",
  external: "arrow-square-out",
  retry: "arrow-clockwise",
  repeat: "repeat",
  sync: "cloud-arrow-down",
  recomputing: "arrows-clockwise",
  reset: "arrow-counter-clockwise",
  export: "download-simple",
  import: "arrow-square-in",
  upload: "upload-simple",
  smoothing: "wave-sine",
  removeFromMembers: "user-minus",
  returningMember: "user-plus",
  fullScreen: "corners-out",
  zoomIn: "magnifying-glass-plus",
  zoomOut: "magnifying-glass-minus",
  dataTable: "table",
  pause: "pause",
  play: "play",
  approve: "thumbs-up",
  turnDown: "thumbs-down",
  planLocked: "lock-simple",
  cannotGrant: "lock-key",
  powerfulRole: "shield-warning",
  warning: "warning",
  hint: "info",
  suggestion: "lightbulb",
  nothingYet: "circle-dashed",
  warmingUp: "hourglass",
  checked: "check",
  denied: "x-circle",
  neutral: "minus",
  none: "prohibit",
  carried: "stack",
  carries: "backpack",
  permissions: "key",
  botToken: "password",
  unlimited: "infinity",
  plan: "package",
  paymentCard: "credit-card",
  date: "calendar-blank",
  time: "clock",
  window: "clock-counter-clockwise",
  history: "archive",
  themeLight: "sun",
  themeDark: "moon",
  caretRight: "caret-right",
  caretLeft: "caret-left",
  caretDown: "caret-down",
  sortAsc: "sort-ascending",
  sortDesc: "sort-descending",
  sortable: "arrows-down-up",
  switchServer: "caret-up-down",
  sidebar: "sidebar-simple",
  drawer: "list",
  next: "arrow-right",
  deltaUp: "arrow-up-right",
  deltaDown: "arrow-down-right",
  search: "magnifying-glass",
  filter: "funnel-simple",
  savedViews: "bookmark-simple",
  noServer: "squares-four",
  resize: "arrows-out-simple",
  formatBold: "text-b",
  formatItalic: "text-italic",
  formatUnderline: "text-underline",
  formatStrike: "text-strikethrough",
  formatSpoiler: "eye-slash",
  formatHeading: "text-h",
  formatList: "list-bullets",
  formatQuote: "quotes",
  formatCode: "code",
  formatLink: "link",
  messagePicture: "image-square",
  file: "paperclip",
  text: "text-t",
  typography: "text-aa",
  messageEmbed: "article",
  messageFooter: "align-bottom",
  messageField: "columns",
  messageColour: "palette",
  messageSection: "square-split-horizontal",
  messageGallery: "grid-four",
  messageSeparator: "split-vertical",
  messageContainer: "bounding-box",
  messageButton: "cursor-click",
  moveUp: "arrow-up",
  moveDown: "arrow-down",
  moveLeft: "arrow-left",
  moveRight: "arrow-right",
  preview: "eye",
  drag: "dots-six-vertical",
  fieldShort: "textbox",
  fieldParagraph: "paragraph",
  fieldChoice: "radio-button",
  fieldCheckboxes: "list-checks",
  fieldCheckbox: "check-square",
  undo: "arrow-u-up-left",
  redo: "arrow-u-up-right",
  cardFigures: "list-numbers",
  cardBar: "chart-bar-horizontal",
  cardRing: "circle-notch",
  cardShape: "shapes",
  hidden: "eye-closed",
  cardPrestige: "crown",
  locked: "lock",
  unlocked: "lock-open",
  cardSelect: "cursor",
  cardLayout: "layout",
  cardGround: "circle-half",
  cardColours: "swatches",
  cardBackground: "image",
  cardRect: "square",
  cardEllipse: "circle",
  cardGradient: "gradient",
  cardOpacity: "drop-half",
  cardAngle: "angle",
  textAlignStart: "text-align-left",
  textAlignCentre: "text-align-center",
  textAlignEnd: "text-align-right",
  cornerRadius: "frame-corners",
  alignLeft: "align-left-simple",
  alignCentre: "align-center-horizontal-simple",
  alignRight: "align-right-simple",
  alignTop: "align-top-simple",
  alignMiddle: "align-center-vertical-simple",
  alignBottom: "align-bottom-simple",
  distributeAcross: "arrows-out-line-horizontal",
  distributeDown: "arrows-out-line-vertical",
} as const satisfies Record<string, string>;

export type IconName = keyof typeof ICONS;

export const FILLED: Readonly<Partial<Record<IconName, string>>> = {
  annotation: "flag-fill",
};

export type HeldGlyph = readonly [outline: string, filled?: string];

export const HELD_GLYPHS = "__colossusGlyphs";

const scope = globalThis as unknown as Partial<Record<typeof HELD_GLYPHS, Map<string, HeldGlyph>>>;
const held = (scope[HELD_GLYPHS] ??= new Map());

export const glyphOf = (name: IconName, fill: boolean): string | undefined => {
  const glyph = held.get(name);
  if (glyph === undefined) return undefined;
  return fill && glyph[1] !== undefined ? glyph[1] : glyph[0];
};
